module.exports = __webpack_public_path__ + "src/assets/img/page1/060bf5c382d4a3a3d81f023b17abb7b5.png";